import CentroCusto from '../../spa/centro-custo/CadastroCentroCusto';

export default {
  path: 'centro-custo',
  name: 'centro-custo',
  component: CentroCusto,
};
